import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { MenuService } from '../../_service/menu/menu.service';
// import { DnDialogService } from 'app/_modules/dn-dialog/dn-dialog.service';
// import { TeaserDetailDialogService } from '../../_modules/dialog/teaser-detail-dialog/teaser-detail-dialog.service';
import { WindowService } from 'app/_service/screen-size.service';

@Component({
  selector: 'app-classified-top-videos',
  templateUrl: './classified-top-videos.component.html',
  styleUrls: ['../../index/index.share.scss', './classified-top-videos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})

export class ClassifiedTopVideosComponent implements OnInit, OnDestroy {
  subscriptions: Array<Subscription> = [];
  randomVideoList = [];
  secondLevelLinks = [];
  listKey;
  rows = 1;

  @Input()
  category;
  @Input()
  title: string;
  @Input()
  link: string;
  @Input()
  ranklink: string;
  @Input()
  linkParams: any;
  @Input()
  slug: string;
  @Input()
  set recommendedVideos(value)
  {
    this._recommendedVideos = value || [];
    this.splitPart();
  };

  get recommendedVideos()
  {
    return this._recommendedVideos;
  }
  @Input()
  showRandomVideos = true;
  @Input()
  blockTitleAsLink = true;
  @Input()
  showRefreshButton = false;
  @Input()
  showHistoryButton = false;
  @Input()
  cid;
  @Input()
  contentLoading = false;
  @Output()
  refreshEvent = new EventEmitter();

  // @Input()
  // autoGet =false;

  getDefaultArray()
  {
    var result = [];
    for(var i=0;i<20;++i)
    {
      result.push({});
    }
    return result;
  }

  _recommendedVideos =[];

  firstPart = [];
  secondPart = [];
  // screenType = ScreenSize;
  // screenSize: ScreenSize = ScreenSize.ExtraLarge;
  // newSvideoSize = {
  //   width: 437,
  //   height: 245,
  // };
  hasWatchedSize = {
    width: 216,
    height: 309,
  };
  newColumn = 4;
  // hasWactchedColumn = 8;
  @ViewChild('track') track: ElementRef;
  currentIndex = 0;

  teaserIndex;
  ifShowed = false;
  ifShowed2 = false;
  showedVideo;
 // private unsub = null;
  // user;
  favoriteLoading = false;

  hoveredCover = null;
  hoveredCover2 = null;

 // newStyle = true; // 启用新的悬停封面简介
  unSetOverflow = true; // 新的悬停封面简介,需要解除轨道overflow限制，并用css隐藏后续项目
  constructor(
    //  private _videoListService: VideoListService,
    //private _randomVideosService: RandomVideosService,
    //private _classifiedTopVideosService: ClassifiedTopVideosService,
    private _windowService: WindowService,
    private _menuSerivce: MenuService,
    // @Inject(AppStore) private store: Store<UsersState>,
   // private _dnDialogService: DnDialogService,
    // private _apiUrlHelper: ApiUrlHelper,
    // private _httpClientHelper: HttpClientHelper,
    //private teaserDetailService: TeaserDetailDialogService,
   // private _userService:UserService
    private _cd: ChangeDetectorRef,
  ) {

  }

  isLargeSize = false;
  splitPart()
  {

    var size =  6;  // large尺寸情况特殊，一排仅取5个
    if(this.rows == 1)
    {
      size = 8;
    }
    this.firstPart = this.recommendedVideos.slice(0,size);
    this.secondPart = this.recommendedVideos.slice(size, size* 2);
    //console.log(this.firstPart,this.secondPart)
    this._cd.detectChanges();
  }
 // isHover = false;
  ngOnInit() {
    // this.unsub = this.store.subscribe(() => this.readState());
    // this.readState();
    this.getListKey();
    // this.subscriptions.push(
    //   // this._windowService.size$.subscribe((value: any) => {
    //   //   //this.screenSize = value;
    //   //   // this.responsiveRowItems = this.trySetresponsiveRowItems();
    //   //   // this.responsiveTeaserSize = this.trySetresponsiveTeaserSize();
    //   // //  this.isLargeSize = value === 4 ? true : false; // large尺寸
    //   //   this.splitPart();
    //   //   //  console.log(this.responsiveRowItems);
    //   // }),
    //   this._randomVideosService.randomVideosSource$.subscribe(r => {
    //     if (this.cid) {
    //       const parentId = this.cid.split(',').slice(0, 3).join(',');
    //       const categoryRandomVideos = r.find(lists => lists.cid === parentId);
    //       if (categoryRandomVideos) {
    //         const randomItems = categoryRandomVideos.lists.find(l => l.cid === this.cid);
    //         if (randomItems && randomItems.cid === this.cid) {
    //           this.randomVideoList = randomItems.items;
    //         }
    //       }
    //     }
    //   })
    // );

    // if (this.autoGet) {
    //   var now = new Date();
    //   now.setMilliseconds(now.getMilliseconds()+ 200);
    //   this.subscriptions.push(
    //     this._classifiedTopVideosService.classifiedTopVideos$
    //     .pipe(delay(now))
    //     .subscribe(r => {
    //       if (this.cid) {
    //         const categoryTopVideos = r[0];
    //         if (categoryTopVideos) {
    //           const topItems = categoryTopVideos.lists.find(l => l.cid === this.cid);
    //           if (topItems && topItems.cid === this.cid) {
    //             this.recommendedVideos = topItems.items;
    //           }
    //         }
    //       }
    //     })
    //   );
    // }

    if (this.actionList.indexOf(this.slug) > -1) {
      this.rows = 2;
    }
  
    if (this.category) {
      this.getSubCategories(this.category.cid);
    }
    if (this.actionList.indexOf(this.slug) == -1 || this.showHistoryButton) {
      this._windowService.size$.subscribe((value: any) => {
        this.detectChange(value);
      });
    }
   
    if(this.showHistoryButton)
    {
      this.newColumn = 8;
    }
     
  }
  display = 1;
  autoHeight = false;
  actionList = ['movie', 'tv-series', 'variety', 'anime',"drama"];
  getListKey() {
    // switch (this.slug) {
    //   case 'movie': {
    //     this.listKey = 'MovieList';
    //     break;
    //   }
    //   case 'tv-series': {
    //     this.listKey = 'TVList';
    //     break;
    //   }
    //   case 'variety': {
    //     this.listKey = 'VarietyList';
    //     break;
    //   }
    //   case 'anime': {
    //     this.listKey = 'AnimeList';
    //     break;
    //   }
    //   case 'sport': {
    //     this.listKey = 'SportList';
    //     break;
    //   }
    //   case 'documentary': {
    //     this.listKey = 'DocumentaryList';
    //     break;
    //   }
    //   case 'chinese': {
    //     this.listKey = 'ChineseList';
    //     break;
    //   }
    //   case 'games': {
    //     this.listKey = 'GameList';
    //     break;
    //   }

    //   case 'JapanKorea': {
    //     this.listKey = 'JapanKoreaList';
    //     break;
    //   }

    //   default: {
    //     this.listKey = 'MovieList';
    //   }
    // }
  }

  readState() {
    // const state: UsersState = this.store.getState()['users'] as UsersState;
    // this.user = state.currentUser;
  }

  getSubCategories(categoryId) {
    this.secondLevelLinks = this._menuSerivce.getSubitemsByCid(categoryId);
    return this._menuSerivce.getSubitemsByCid(categoryId);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
   // if (this.unsub) this.unsub();
  }

  // responsiveMarginRight(isLast) {
  //   if (isLast) {
  //     return 0;
  //   }
  //   return 5;
  // }
  // responsiveTeaserSize = {
  //   width: 216,
  //   height: 362
  // };
  // responsiveRowItems = { first: 6, second: 6 };
  // trySetresponsiveTeaserSize() {

  //   if (this.screenSize == this.screenType.Large) {
  //     return {
  //       width: 213,
  //       height: 358

  //     }
  //   }
  //   if (this.screenSize == this.screenType.ExtraLarge) {
  //     return {
  //       width: 216,
  //       height: 362
  //     };
  //   }
  //   return { width: 206, height: 348 };

  // }
  // // responsiveTeaserSize() {
  // //   return { width: 238, height: 400 }
  // //  // return { width: 238, height: 400 };
  // // }
   responseList = ['movie','drama', 'tv-series', 'variety', 'anime', 'japanKorea', 'europe', 'china', 'cartoon', 'other', 'vr'];
  // trySetresponsiveRowItems() {

  //   if (this.responseList.indexOf(this.slug) == -1) {
  //     switch (this.screenSize) {
  //       case this.screenType.XSmall:
  //         return { first: 4, second: 4 };
  //       case this.screenType.Small:
  //         return { first: 6, second: 6 };
  //       case this.screenType.Medium:
  //         return { first: 6, second: 6 }; /// 没有排行版
  //       case this.screenType.Large:
  //         return { first: 7, second: 5 };
  //       // case this.screenType.ExtraLarge:
  //       //   return { first: 6, second: 6 };
  //       default:
  //         return { first: 8, second: 6 };
  //     }

  //   }
  //   else {
  //     switch (this.screenSize) {
  //       case this.screenType.XSmall:
  //         return { first: 4, second: 4 };
  //       case this.screenType.Small:
  //         return { first: 6, second: 6 };
  //       case this.screenType.Medium:
  //         return { first: 6, second: 6 }; /// 没有排行版
  //       case this.screenType.Large:
  //         return { first: 5, second: 5 };

  //       default:
  //         return { first: 6, second: 6 };
  //     }
  //   }
  // }

  getGuessYouLikeVideos() {
    this.refreshEvent.emit();
  }

  arrayCounter(i: number) {
    return new Array(i);
  }

  showDetail(i, item) {
    this.teaserIndex = i;
    this.ifShowed = true;
    this.showedVideo = item;
    // console.log(item);
  }

  closeDetail(i) {
    this.teaserIndex = i;
    this.ifShowed = false;
  }

  showDetail2(i, item) {
    this.teaserIndex = i;
    this.ifShowed2 = true;
    this.showedVideo = item;
    // console.log(item);
  }

  closeDetail2(i) {
    this.teaserIndex = i;
    this.ifShowed2 = false;
  }

  replaceComma(r) {
    if (r !== null && r !== undefined) {
      return r.replace(/,/g, ' / ');
    }
  }


  openTeaserDialog($event: any, video) {
    $event.preventDefault();
    $event.stopPropagation();
 
  }

  // cidMapperArray(cidMapper) {
  //   return cidMapper.split(',');
  // }

  private detectChange(value)
  {
    if(this.showHistoryButton)
    {
      //console.log(value);
      var previous = this.newColumn;
      let current = value >=5?8:value == 4?7:6;
      this.newColumn = current;
      if(previous != current)
      {
        this.moveTrack();
        this._cd.detectChanges();
      }
    }
    else
    {
      var previous = this.newColumn;
      let current = value == 5?4:3;
      this.newColumn = current;
      if(previous != current)
      {
        this.moveTrack();
        this._cd.detectChanges();
      }
    }
 
  
  }
  getSliderTrackItemSize() {
    // if (this.screenSize === ScreenSize.XSmall) {
    //   this.newSvideoSize = {
    //     width: 420,
    //     height: 420 / 16 * 9,
    //   };
    //   this.newColumn = 3;
    //   this.hasWatchedSize = {
    //     width: 207,
    //     height: 296,
    //   };
    //   this.hasWactchedColumn = 6;
    // } else if (this.screenSize === ScreenSize.Small) {
    //   this.newSvideoSize = {
    //     width: 420,
    //     height: 420 / 16 * 9,
    //   };
    //   this.newColumn = 3;
    //   this.hasWatchedSize = {
    //     width: 207,
    //     height: 296,
    //   };
    //   this.hasWactchedColumn = 6;
    // } else if (this.screenSize === ScreenSize.Medium) {
    //   this.newSvideoSize = {
    //     width: 420,
    //     height: 420 / 16 * 9,
    //   };
    //   this.newColumn = 3;
    //   this.hasWatchedSize = {
    //     width: 207,
    //     height: 296,
    //   };
    //   this.hasWactchedColumn = 6;
    // } else if (this.screenSize === ScreenSize.Large) {
    //   this.newSvideoSize = {
    //     width: 438,
    //     height: 438 / 16 * 9,
    //   };
    //   this.newColumn = 3;
    //   this.hasWatchedSize = {
    //     width: 216,
    //     height: 309,
    //   };
    //   this.hasWactchedColumn = 7;
    // } else if (this.screenSize === ScreenSize.ExtraLarge) {
    //   this.newSvideoSize = {
    //     width: 437,
    //     height: 437 / 16 * 9,
    //   };
    //   this.newColumn = 4;
    //   this.hasWatchedSize = {
    //     width: 216,
    //     height: 309,
    //   };
    //   this.hasWactchedColumn = 8;
    // } else {
    //   this.newSvideoSize = {
    //     width: 437,
    //     height: 437 / 16 * 9,
    //   };
    //   this.newColumn = 4;
    //   this.hasWatchedSize = {
    //     width: 216,
    //     height: 309,
    //   };
    //   this.hasWactchedColumn = 8;
    // }
    // this.moveTrack();
    // this._cd.detectChanges();
  }

  navLast() {
    if (this.currentIndex === this.newColumn) {
      this.unSetOverflow = false;
    }
    this.currentIndex -= this.newColumn; // 一次滑动的数量根据尺寸来定
    if (this.currentIndex < 0) {
      this.currentIndex = 0;
    }
    // console.log(this.currentIndex);
    this.moveTrack(true);
  }

  navNext() {
    this.unSetOverflow = true;
    this.currentIndex += this.newColumn; // 一次滑动的数量根据尺寸来定
    // console.log(this.currentIndex);
    this.moveTrack(true);
  }

  moveTrack(useAnimation = false) {
    const trackElement = this.track?.nativeElement;
    // console.log(trackElement);
    if (!!trackElement) {
      let box =this.showHistoryButton?  trackElement.getElementsByClassName("video-item").item(0):trackElement.getElementsByClassName("new-svideo-container").item(0);
      if(box== null)
      {
        return;
      }
      console.log
      if (useAnimation) {
        trackElement.classList.add('animation');
      } else {
        trackElement.classList.remove('animation');
      }
      const properIndex = (this.recommendedVideos.length - this.newColumn);
      if (this.currentIndex >= properIndex) {
        this.currentIndex = properIndex > 0 ? properIndex : 0;
      }
      const trackItemWitdh =box.clientWidth;// this.showHistoryButton ? this.hasWatchedSize.width : this.newSvideoSize.width;
      trackElement.style.transform = `translate3d(${ (trackItemWitdh + 5) * -(this.currentIndex) }px, 0px, 0px)`;
      setTimeout(() => {
        this.unSetOverflow = true;
      }, 0);
    }
  }

}

